export default {
    NONE: 'None',
    RATE: 'Rate',
    CONTACT: 'Contact',
    CONTACTED: 'Contacted',
    REVIEWED: 'Claimed',
    INTERVIEW_AND_ASSESSMENT: 'Interview-Assessment',
    HIRED: 'Hired',
    REJECTED: 'Rejected',
    DECLINED: 'Declined',
    FEEDBACK: 'Feedback',
    SAMPLES: 'Samples',
};

export const WORKFLOW_STEP_UNKNOWN = 'unknown';

/*
    CONTACT -- Qualified on UI
    CONTACTED -- Contacted on UI
    REVIEWED -- Interested on UI
    INTERVIEW_AND_ASSESSMENT -- Interview on UI
 */
